import React, { useEffect } from 'react';
import { useLocation } from "react-router-dom";
import '../styles/Unsubscribe.css';
import { Button } from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import TwitterIcon from '@material-ui/icons/Twitter';
import InstagramIcon from '@material-ui/icons/Instagram';
import FacebookIcon from '@material-ui/icons/Facebook';
import Header from "./Header";
import http from '../http.js';

export default function Unsubscribe() {
    let query = new URLSearchParams(useLocation().search);
    let email = atob(query.get("account"));

    useEffect(() => {
        async function deleteSubscriber() {
            var data = {
                email: email
            }
            try {
                const result = await http.post('/unsubscribe', data);
                console.log(result);
            } catch(e) {
                console.log(e);
            }
        }
        deleteSubscriber();
    }, [email]);

    return (
        <div>
            <Header />
            <div className="Unsubscribe" style={{ textAlign: 'center', maxWidth: 900, margin: '0 auto', padding: '32px 16px' }}>
                <h2 style={{ color: '#2196f3', fontWeight: 700, marginBottom: 0, fontSize: '1.5rem' }}>{email}</h2>
                <h1 style={{ fontSize: '2.5rem', fontWeight: 700, marginBottom: 24, marginTop: 8 }}>
                    You’ve been unsubscribed
                </h1>
                <div style={{ fontSize: '1.15rem', marginBottom: 18 }}>
                    We’re sorry to see you go! You will no longer receive our newsletter at this address.<br />
                    If you change your mind, you can re-subscribe at any time.
                </div>
                <Button
                    style={{ width: 260, fontSize: '1.1rem', fontWeight: 600, margin: '16px 0', background: '#2196f3' }}
                    className="subscribeButton"
                    variant="contained"
                    color="primary"
                    href="/"
                    disableElevation
                >
                    SUBSCRIBE TO NEWSLETTER
                </Button>
                <div style={{ fontSize: '1.1rem', margin: '32px 0 18px 0' }}>
                    In the meantime, feel free to explore our website or follow us on social media for updates about Los Angeles.
                </div>
                <Button
                    style={{ width: 260, fontSize: '1.1rem', fontWeight: 600, margin: '0 0 24px 0' }}
                    className="manageButton"
                    variant="contained"
                    color="primary"
                    href="https://xtown.la/"
                    disableElevation
                >
                    EXPLORE CROSSTOWN &ensp;<ArrowForwardIcon />
                </Button>
                <div className="socialMediaIcons" style={{ marginTop: 12 }}>
                    <TwitterIcon color='primary' fontSize='large' style={{ margin: '0 8px' }} />
                    <InstagramIcon color='primary' fontSize='large' style={{ margin: '0 8px' }} />
                    <FacebookIcon color='primary' fontSize='large' style={{ margin: '0 8px' }} />
                </div>
            </div>
        </div>
    )
}